import { FORM_ERROR } from "final-form";
import useGlobalContext from "hooks/globalData";
import useTrashablePromises from "hooks/useTrashablePromises";
import { useIntl } from "react-intl";
import {
  IQuestion,
  SaveQuestion,
} from "services/KnowfullyAdminClient";
import { Mode } from "types/common-types";
import translateError from "utils/translateError";
import QuestionForm, { QuestionFormSubmitValues } from "./QuestionForm";

type QuestionUpdateFormProps = {
  question: IQuestion;
  onQuestionUpdated: () => void;
  onCancel: () => void;
};

const QuestionUpdateForm = ({
  question,
  onQuestionUpdated,
  onCancel,
}: QuestionUpdateFormProps) => {
  const { registerPromise } = useTrashablePromises();
  const { formatMessage: t } = useIntl();
  const { questionService } = useGlobalContext();

  const onSubmit = async (values: QuestionFormSubmitValues) => {
    try {
      const response = await registerPromise(
        questionService.saveQuestion(
          new SaveQuestion({
            ...values,
            id: question.id,
            organizationId: question.organizationId!,
          })
        )
      );
      onQuestionUpdated();
      return response;
    } catch (error) {
      console.log(error);
      return { [FORM_ERROR]: translateError(error, t) };
    }
  };

  return (
    <QuestionForm
        question={question}
        onSubmit={onSubmit}
        submitLabel={t({ id: "questionFormUpdateButton" })}
        onCancel={onCancel}
        mode={Mode.Update}
      />
  );
};

export default QuestionUpdateForm;
